import PageShell from "./PageShell";

export default function Terms() {
  return (
    <PageShell testId="terms-page" eyebrow="Legal" title="Terms & Conditions" intro="The terms under which Agroya Refinery LLP provides its website and services." seo={{title:"Terms & Conditions · Agroya Refinery LLP", description:"Terms of use for the Agroya Refinery LLP website and services.", canonical:"https://agroya1935.com/terms"}}>
      <p>By accessing this website you agree to be bound by these Terms.</p>
      <h3>Services</h3>
      <p>Agroya Refinery LLP provides precious metal refining, recovery, assaying and bullion manufacturing services subject to separate service agreements.</p>
      <h3>Intellectual Property</h3>
      <p>All content on this website is owned by Agroya Refinery LLP and may not be reproduced without written consent.</p>
      <h3>Limitation of Liability</h3>
      <p>Agroya Refinery LLP shall not be liable for any indirect, incidental or consequential damages arising from use of this website.</p>
      <h3>Governing Law</h3>
      <p>These Terms are governed by the laws of India and subject to the jurisdiction of courts in Pune, Maharashtra.</p>
    </PageShell>
  );
}
